// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ViewUI from "view-design";
import "babel-polyfill";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
/*import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'*/
import { isEmpty } from "@/utils";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import { Message } from "element-ui";
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
// import style
import "view-design/dist/styles/iview.css";
//引入全局css
import "./assets/css/common.css";
import store from "@/vuex/store";
import "@/styles/index.less"; // 全局样式

//引入axios请求数据
import axios from "axios";
import http from "./utils/http";
import Qs from "qs";
// main.js
import noLogin from "./components/popup";
// 全局未登录
Vue.prototype.$noLogin = noLogin.install;

/*import http from '@/request'; // 引入接口列表*/

Vue.use(ViewUI);

Vue.prototype.axios = axios;
Vue.prototype.$http = http;
Vue.prototype.qs = Qs;
/*Vue.prototype.$http = http; // 将接口列表挂载到全局*/

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  console.log("路由拦击", to.meta.isAllowNoLogin);
  console.log("路由拦击", to.path);
  if (!to.meta.isAllowNoLogin) {
    // 判断该路由是否需要登录权限
    if (isEmpty(window.sessionStorage.getItem("userName"))) {
      // 获取当前的token是否存在
      console.log("没登录");
      noLogin.install();
      // this.$noLogin();
    } else {
      if (!isEmpty(window.sessionStorage.getItem("userInfo"))) {
        let uInfo = JSON.parse(window.sessionStorage.getItem("userInfo")) || {};
        // 拦截/NewSpecialOffer）和新人优惠券（NewCoupons）页面
        if (
          (to.path === "/NewSpecialOffer" || to.path === "/NewCoupons") &&
          uInfo.new_customer !== 1
        )
          Message.error("你不是新用户，暂不可享受新人福利");
        else {
          console.log("正常登录");
          ViewUI.LoadingBar.start();
          next();
        }
      }
    }
  } else {
    console.log("不拦截");
    // 如果不需要权限校验，直接进入路由界面
    ViewUI.LoadingBar.start();
    next();
  }
});

router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js